<template>
	<div class="animated fadeIn">


		<div class="row">
			<div class="col-xs-12" v-if="video && video.poster && video.poster.url && video.tank && video.tank.url">
				<NbVideo :video="video"/>
			</div>
			<div class="col-xs-12">
				<div class="mv10">
					<NbTank :tank="video.tank" :edit="false"/>
				</div>

			</div>
			<div class="col-xs-12">
				<div v-html="video.description"></div>
			</div>
		</div>

	</div>

</template>
<script>
	import {Notification} from 'element-ui';
	import Video from '../../../common/model/video/Video'
	import NbVideo from '../../../common/widget/NbVideo.vue'
	import NbTank from '../../../common/widget/NbTank.vue'

	export default {

		data () {
			return {
				video: new Video()
			}
		},
		components: {
			NbVideo,
			NbTank
		},
		methods: {},
		mounted(){
			let that = this;
			this.video.id = this.$store.state.route.params.id;
			if (this.video.id) {



				this.video.httpDetail(function () {



					let video = that.video;

				});
			}
		}
	}
</script>



// WEBPACK FOOTER //
// Detail.vue?1332abc6